<template>
  <div class="teachingActivity">
    <div class="activity_box">
      <div class="header">
        <div class="click_item" v-for="item in operateList" :key="item.name" @click="selectButton(item)">
          <span class="icon_box"><i class="iconfont" :style="{color:item.color,fontSize:'22px'}" v-html="item.icon"></i></span><span>{{ item.name }}</span>
        </div>
        <el-dialog :title="dialogTitle" :visible.sync="activtityDialogVisable" width="650px" :before-close="cancle" :close-on-click-modal="false">
          <div class="dialog_box">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="活动名称" prop="name">
                <el-input style="width: 440px;" show-word-limit :maxlength="18" v-model="ruleForm.name" placeholder="请输入活动名称"></el-input>
              </el-form-item>
              <el-form-item label="活动主题" prop="contents" v-if="seletcButtonIndex==5">
                <el-input type="textarea" autosize placeholder="请输入活动主题" v-model="ruleForm.contents" show-word-limit :maxlength="500">
                </el-input>
              </el-form-item>
              <el-form-item label="活动时长" prop="duration" v-if="seletcButtonIndex!=6">
                <el-radio-group v-model="ruleForm.duration">
                  <el-radio :label="item.value" v-for="item in durationList" :value="item.value" :key="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="投票选项" prop="duration" v-if="seletcButtonIndex==2">
                <div>
                  <div v-for="(vote , index) in ruleForm.voteSelect" :key="index">
                    <el-input @blur="changeInput($event,vote.name,index)" show-word-limit :maxlength="30" style="margin-bottom: 10px;width: 440px;" v-model="vote.name" placeholder="请输入选项"></el-input>
                    <span v-if="index>1" style="margin-left: 10px; color: red;" @click="deleteOption(index)">删除</span>
                  </div>
                </div>
                <el-button class="addSelect" :disabled="ruleForm.voteSelect.length==10" @click="addOptions">添加选项</el-button>
              </el-form-item>
              <el-form-item label="试卷名称" prop="paperId" v-if="seletcButtonIndex==6">

                <el-select v-model="ruleForm.paperId" placeholder="请选择试卷" clearable style="width: 100%;">
                  <el-option v-for="paperItem in paperList" :label="paperItem.name" :value="paperItem.resource_id" :key="paperItem.resource_id"></el-option>
                </el-select>

              </el-form-item>
              <el-form-item v-if="seletcButtonIndex==6" label="活动时间" prop="duration">
                <el-input-number :precision="0" v-model="ruleForm.duration" :controls="false" class="pw-input" :min="0" :max="99999999" style="width: 175px;">
                </el-input-number>
                <span style="margin-left: 5px">分钟</span>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancle">取 消</el-button>
            <el-button type="primary" style="background-color:#4F7BFD ;color: #fff;" @click="confirmFn('ruleForm')">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <div class="activity_list">
        <div class="list_box" v-if="activityList.length!=0">
          <div class="activity_item" v-for="item in activityList" :key="item.id" @click="getDetial(item)">
            <div class="icon_box">
              <i class="iconfont" :style="{color:operateList[item.type-1].color,fontSize:'22px'}" v-html="operateList[item.type-1].icon"></i>
            </div>
            <div class="activity_info">
              <div class="activity_name"><span class="activity_type">[{{ operateList[item.type-1].name }}]</span><span class="activity_type">{{ item.name }}</span><span
                  :style="{color:item.status==1?'#21B94B':'#4E5569',background:item.status==1?'rgba(33,185,75,0.1)':'#E5E7EB',padding:'2px 3px', borderRadius: '4px',fontSize:'12px'}">{{ item.status==1?"进行中":'已结束' }}</span></div>
              <div class="create_time">
                <div class="left">
                  <div>创建时间:{{ item.create_time }}</div>
                  <div style="margin-left: 20px;" v-if="item.type==1 || item.type==2">{{  item.total_participants}}人提交</div>
                </div>
                <div class="right">
                  <div class="end_activity" v-if=" item.status==1" @click.stop="endActivity(item.id)"><i class="el-icon-video-play" style="margin-right: 5px;"></i>结束活动</div>
                  <div class="delete_button" @click.stop="deleteActivity(item.id)"><i class="el-icon-delete" style="margin-right: 5px;"></i>删除</div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="pagination" v-if="activityList.length!=0">
          <el-pagination @current-change="handleCurrentChange" :current-page="pageParams.page" :page-size="pageParams.size" background layout="prev, pager, next" :total="pageParams.total">
          </el-pagination>
        </div>
        <div class="list_box" v-else style="color: #666;display: flex;align-items: center;justify-content: center; height: 300px;">
          暂无活动
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import WsConfig from "@/utils/wsConfig";
import { sendWsData } from "@/utils/utils";
export default {
  name: "teacherTextbook",
  components: {},
  data() {
    return {
      operateList: [
        {
          name: "签到",
          id: 1,
          title: "发起签到",
          icon: "&#xe768;",
          color: "#2654FF",
        },
        {
          name: "投票",
          id: 2,
          title: "发起投票",
          icon: "&#xe767;",
          color: "#EE7218",
        },
        {
          name: "选人",
          id: 3,
          title: "发起选人",
          icon: "&#xe766;",
          color: "#2654FF",
        },
        {
          name: "抢答",
          id: 4,
          title: "发起抢答",
          icon: "&#xe763;",
          color: "#EE7218",
        },
        {
          name: "主题讨论",
          id: 5,
          title: "发起主题讨论",
          icon: "&#xe765;",
          color: "#2654FF",
        },
        {
          name: "随堂练习",
          id: 6,
          title: "随堂练习",
          icon: "&#xe764;",
          color: "#0092FF",
        },
      ],
      durationList: [
        {
          label: "1分钟",
          value: 1,
        },
        {
          label: "2分钟",
          value: 2,
        },
        {
          label: "3分钟",
          value: 3,
        },
        {
          label: "5分钟",
          value: 5,
        },
        {
          label: "不限时",
          value: 0,
        },
      ],
      ruleForm: {
        course_id: this.$route.query.course_id,
        course_chapter: this.$route.query.zhangIndex,
        course_node: this.$route.query.jieIndex,
        class_id: void 0,
        name: "",
        type: this.seletcButtonIndex,
        duration: 1,
        voteSelect: [
          { name: "", id: 1 },
          { name: "", id: 2 },
        ],
        paperId: void 0,
        paper_time: void 0,
        contents: "", //活动主题
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 2, max: 18, message: "长度在2到18个字符", trigger: "blur" },
        ],
        duration: [
          { required: true, message: "请输入活动时长", trigger: "blur" },
        ],
        contents: [
          { required: true, message: "请输入主题内容", trigger: "blur" },
          { min: 2, max: 500, message: "长度在2到500个字符", trigger: "blur" },
        ],
        paperId: [
          { required: true, message: "请选择试卷", trigger: "change" }
        ],

      },
      seletcButtonIndex: 4,
      dialogTitle: "发起签到",
      activtityDialogVisable: false,
      wsIns: null,
      wsTimer: null,
      paperList: [],
      pageParams: {
        page: 1,
        size: 10,
        total: 0,
      },
      activityList: [],
    };
  },
  created() {
    this.websocketInit();
    this.getLessonQuizList();
    this.getActivityList();
  },

  methods: {
    selectButton(item) {
      this.seletcButtonIndex = item.id;
      this.dialogTitle = item.title;
      this.activtityDialogVisable = true;
    },
    websocketInit() {
      this.wsIns = new WebSocket(WsConfig.url);
      console.log("WsConfig.url", WsConfig.url);

      this.wsIns.onopen = () => {
        this.wsIns.send(sendWsData("bind"));
        if (this.wsTimer) clearInterval(this.wsTimer);
        this.wsTimer = setInterval(() => {
          const sendMsg = sendWsData("ping");
          this.wsIns.send(sendMsg);
        }, 50000);
      };
      this.wsIns.onmessage = (evt) => {
        const data = JSON.parse(evt.data);
        switch (data.type) {
          // 连接成功
          case "connect":
            this.bindClient(data.data.client_id);
            break;
          case "new_act":
            // console.log("收到新活动通知：", data);
            break;
          case "stop_act":
            // console.log("活动停止：", data);
            break;
          case "del_act":
            // console.log("活动删除：", data);
            break;
          case "join_group":
            // console.log("加入班级", data);

            break;
          case "reset_select_person":
            // console.log("重置选人", data);

            break;
          case "rand_select_person":
            // console.log("随机选人ttt", data);
            break;
          default:
          // console.log("收到未知类型消息：", data);
        }
      };
      //断开之后重连
      this.wsIns.onclose = () => {
        console.log("已断开连接，尝试重新连接");
        this.websocketInit();
      };
    },
    confirmFn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 发起活动
          let param = {
            class_id: localStorage.getItem("class_id"),
            course_id: this.$route.query.course_id,
            course_chapter: this.$route.query.zhangIndex,
            course_node: this.$route.query.jieIndex,
            name: this.ruleForm.name,
            type: this.seletcButtonIndex,
            duration: this.ruleForm.duration,
            option: [],
            contents: this.ruleForm.contents,
          };
          switch (this.seletcButtonIndex) {
            case 1:
              // jdActivitiesAdd

              break;
            case 2:
              for (let i = 0; i < this.ruleForm.voteSelect.length; i++) {
                if (!this.ruleForm.voteSelect[i].name) {
                  this.$message.warning("选项值不能为空!");
                  return;
                }
              }
              param.option = this.ruleForm.voteSelect.map((item) => item.name);
              break;
            case 3:
              // 选人
              break;
            case 4:
              console.log("抢答了哈哈哈");

              break;
            case 5:
              // 主题讨论
              break;
            case 6:
              // 随堂练习
              param = {...param, paperId: this.ruleForm.paperId }
              break;
          }
          console.log(param)
          // return
          this.$shttp.axiosPost(
            this.$api.jdActivitiesAdd,
            param,
            (res) => {
              if (res.code == 200) {
                this.$message.success("创建成功");
                this.activtityDialogVisable = false;
                this.getActivityList();
                this.$refs[formName].resetFields();
                this.ruleForm.voteSelect=[
                  { name: "", id: 1 },
                  { name: "", id: 2 },
                ]
              }
            },
            (err) => {
              console.log(err);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 绑定客户端
    bindClient(client_id) {
      this.$shttp.axiosPost(
        this.$api.jdWsBind,
        { client_id: client_id, class_id: localStorage.getItem("class_id") },
        (res) => {},
        (err) => {
          console.log(err);
        }
      );
    },
    cancle() {
      this.activtityDialogVisable = false;
      this.$refs.ruleForm.resetFields();
      this.ruleForm.voteSelect=[
          { name: "", id: 1 },
          { name: "", id: 2 },
        ]
    },
    addOptions() {
      let obj = {
        name: "",
        id: 1,
      };
      this.ruleForm.voteSelect.push(obj);
    },
    deleteOption(index) {
      this.ruleForm.voteSelect.splice(index, 1);
    },
    changeInput(event, name, index) {
      console.log("name", name);
      for (let i = 0; i < this.ruleForm.voteSelect.length; i++) {
        if (
          this.ruleForm.voteSelect[i].name.trim() === name.trim() &&
          index !== i &&
          name
        ) {
          this.$message.warning("选项的名字不能重复");
          this.ruleForm.voteSelect[index].name = "";
          break;
        }
      }
    },
    getPaperList() {
      let params = {
        id: this.$route.query.course_id,
        course_chapter: this.$route.query.zhangIndex,
        course_node: this.$route.query.jieIndex,
      };
      this.$shttp.axiosGetBy(
        this.$api.exmapapers,
        params,
        (res) => {
          console.log(res, "res.list");
          if (res.code === 200) {
            this.paperList = res.list;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getLessonQuizList() {
      let param = {
        course_id: this.$route.query.course_id,
        course_chapter: this.$route.query.zhangIndex,
        course_node: this.$route.query.jieIndex,
      };
      //先查询课程那边自定义/拖拽保存的小测列表
      this.$shttp.axiosGetBy(
        this.$api.course_getcoursecustom,
        param,
        (res) => {
          if (res.code === 200) {
            //没有数据的话就查询总管理员创建课程时拖拽保存的小测列表
            if (res.data.length === 0) {
              this.getPaperList();
            } else {
              if (res.data.exams) {
                let arrList = res.data.exams;
                let paper_list = [];
                arrList.forEach((item) => {
                  let obj = {
                    name: item.paper_name,
                    resource_id: item.id,
                  };
                  paper_list.push(obj);
                });
                this.paperList = paper_list;
              } else {
                this.paperList = [];
              }
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getActivityList() {
      let params = {
        class_id: localStorage.getItem("class_id"),
        page: this.pageParams.page,
        page_size: this.pageParams.size,
        course_id: this.$route.query.course_id,
        course_chapter: this.$route.query.zhangIndex,
        course_node: this.$route.query.jieIndex,
      };
      this.$shttp.axiosPost(
        this.$api.jdActivities,
        params,
        (res) => {
          if (res.code === 200) {
            console.log("list", res);
            this.pageParams.total = res.data.total;
            this.activityList = res.data.data;
            console.log(this.activityList, " this.activityList");
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    endActivity(id) {
      // 结束活动
      // jdActivitiesStop
      this.$confirm("是否结束活动, 结束后学生无法进行操作?", "结束活动", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$shttp.axiosPost(
            this.$api.jdActivitiesStop,
            { id: id },
            (res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "活动终止!",
                });
                this.getActivityList();
              }
            },
            (err) => {
              console.log(err);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    deleteActivity(id) {
      // 删除活动
      this.$confirm("是否删除该活动,删除后将无法恢复?", "删除活动", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$shttp.axiosPost(
            this.$api.jdActivitiesDel,
            { id: id },
            (res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getActivityList();
              }
            },
            (err) => {
              console.log(err);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getDetial(item) {
      localStorage.setItem(
        "query",
        JSON.stringify({
          id: item.id,
          name: item.name,
          type: item.type,
          create_time: item.create_time,
          duration: item.duration,
          status: item.status,
          jieName: this.$route.query.jieName,
          zhangName: this.$route.query.zhangName,
        })
      );
      this.$router.push({
        path: "/qualityCourse/teacher/teachingActivityDetial",
      });
    },
    handleCurrentChange(val) {
      this.pageParams.page = val;
      this.getActivityList()
    },
  },
};
</script>

<style scoped lang="scss">
.teachingActivity {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .activity_box {
    width: 100%;
    height: calc(100vh - 156px);
    overflow-y: auto;
    background: #fff;
    .header {
      display: flex;
      justify-content: flex-end;
      height: 70px;
      align-items: center;
      padding: 0 30px;
      box-sizing: border-box;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      .click_item {
        display: flex;
        align-items: center;
        margin-left: 30px;
        cursor: pointer;
        .icon_box {
          display: flex;
          width: 40px;
          height: 40px;
          background: #f5f5f5;
          border-radius: 4px 4px 4px 4px;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
        }
      }
    }
  }
}

.dialog_box {
  max-height: 500px;
  overflow-y: auto;
  padding-right: 20px;
  box-sizing: border-box;
}
.el-radio {
  margin-bottom: 0;
}
.addSelect {
  width: 88px;
  height: 36px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #006eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #006eff;
}
::v-deep .el-radio__label {
  min-width: 10px;
  display: inline-block;
  background: none !important;
  color: #333;
  border-radius: 0;
  border: none;
  padding: 0px;
  padding-left: 8px;
  margin-left: 0px;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  border: none !important;
  color: #333 !important;
}
::v-deep .el-radio-group {
  height: 98%;

  padding: 0;
  padding-left: 0;
  box-sizing: border-box;
}
/* 设置滚动条整体 */
::-webkit-scrollbar {
  width: 3px; /* 滚动条宽度 */
  height: 6px; /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道背景色 */
}

/* 设置滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #d3d3d3; /* 滑块背景色 */
  border-radius: 10px; /* 滑块圆角 */
}

/* 设置滚动条滑块悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #a3a2a2; /* 滑块悬停背景色 */
}
::v-deep .el-input__inner {
  background: #fff !important;
}
::v-deep .el-textarea__inner {
  min-height: 100px !important;
}
.activity_list {
  width: 100%;
  padding: 20px 30px;
  box-sizing: border-box;
  .list_box {
    width: 100%;
    .activity_item {
      border-top: 1px solid #dddddd;
      padding: 20px 30px;
      box-sizing: border-box;
      display: flex;
      cursor: pointer;
      &:nth-last-of-type(1) {
        border-bottom: 1px solid #dddddd;
      }
      .icon_box {
        display: flex;
        width: 40px;
        height: 40px;
        background: #f5f5f5;
        border-radius: 4px 4px 4px 4px;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
      }
      .activity_info {
        width: 100%;
        .activity_name {
          .activity_type {
            font-family: PingFang SC, PingFang SC;
            font-size: 14px;
            color: #333333;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            font-weight: 600;
            margin-right: 10px;
          }
        }
        .create_time {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 6px;
          .left {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #999999;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: flex;
            align-items: center;
          }
          .right {
            display: flex;
            align-items: center;
            .end_activity {
              color: #4f7bfd;
              margin-right: 10px;
              cursor: pointer;
            }
            .delete_button {
              color: #fd4f4f;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
  }
}
.dialog-footer {
  display: flex;
  justify-content: end;
  .el-button {
    width: 88px;
    height: 36px;
    background: #f2f4f7;
    border-radius: 4px 4px 4px 4px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #3e3e3e;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>